import React, { createContext, useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useMatch, useNavigate } from "react-router";
import { Slide, toast } from "react-toastify";
import { ReactComponent as Back } from "../../assets/icons/back.svg";
import Layout from '../../../../src/components/Layout'
import CardDetails from "../../components/TransactionComponents/CardDetails";
import TransactionDetails from "../../components/TransactionComponents/TransactionDetails";
import axios from "../../plugins/axios";
import { viewTransaction } from "../../plugins/urls";

export const TransactionContext = createContext();
const Transaction = () => {
  const navigate = useNavigate();
  const match = useMatch("/transaction/:id");
  const id = match ? match.params.id : "";
  const [state, setState] = useState({
    referenceID: "",
    transactionCategory: "",
    terminalType: "",
    paymentMethod: "",
    amount: "",
    terminalId: "",
    paymentStatus: "",
    businessName: "",
    channel: "",
    wayaposFees: "",
    date: "",
    message: "",
    cardType: "",
    cardNumber: "",
    authCode: "",
    issuingBank: "",
    country: "",
    transactionLocation: "",
    paymentProcessor: "",
    deviceType: "",
    billerName: "",
    productName: "",
    customerIdentifier: "",
    sourceAccount: "",
    sourceAccountName: "",
    destinationAccount: "",
    thirdPartyReference: "",
  });
  useEffect(() => {
    axios({ url: `${viewTransaction}?id=${id}`, method: "GET" })
      .then((res) => {
        if (res.data.respCode === 0) {
          const {
            reference,
            transactionType,
            amount,
            terminalId,
            status,
            channel,
            createdAt,
            responseMessage,
            // AIRTIME_PURCHASE fields
            billerName,
            productName,
            customerIdentifier,
            // CARD_PAYMENT fields
            sourceAccountName,
            destinationAccount,
            thirdPartyReference,
            // Common fields
            sourceAccount,
          } = res.data.respBody;
          setState((state) => ({
            ...state,
            referenceID: reference || "",
            transactionCategory: transactionType || "",
            amount: amount || 0,
            terminalId: terminalId || "",
            paymentStatus: status || "",
            paymentMethod: channel || "", // Use channel as paymentMethod
            date: createdAt || "",
            message: responseMessage || "",
            sourceAccount: sourceAccount || "",
            // Fields that might not be in all responses
            billerName: billerName || "",
            productName: productName || "",
            customerIdentifier: customerIdentifier || "",
            sourceAccountName: sourceAccountName || "",
            destinationAccount: destinationAccount || "",
            thirdPartyReference: thirdPartyReference || "",
            // Fields not in the new responses
            terminalType: "",
            businessName: "",
            wayaposFees: "",
            cardType: "",
            cardNumber: "",
            authCode: "",
            issuingBank: "",
            country: "",
            transactionLocation: "",
            paymentProcessor: "",
            deviceType: "",
            channel: channel || "", // also keep channel for other components if needed
          }));
        }
      })
      .catch((err) => {
        toast.error(`${err.response.data.message}`, {
          transition: Slide,
          hideProgressBar: true,
          autoClose: 3000,
        });
      });
  }, [id]);
  return (
    <Layout title={`Transactions>${id}`}>
      <TransactionContext.Provider
        value={{
          state,
        }}
      >
        <div className="font-default address">
          <h4
            className="text-darker fs-14 fw-700 cursor-pointer ms-2"
            onClick={() => navigate(-1)}
          >
            <span className="mr-15">
              <Back />
            </span>
            Back
          </h4>

          <Row className="mt-20 px-3">
            <TransactionDetails />
            {/*<CardDetails />*/}
          </Row>
        </div>
      </TransactionContext.Provider>
    </Layout>
  );
};

export default Transaction;
